<div class="mct-flex mct-row mct-justify-between mct-items-start">
  <h4>{{ 'profiles.view.member-activity.label' | translate | titlecase }}</h4>
  <div class="mct-flex mct-row mct-justify-start mct-items-center mct-gap-27">
    <a [hidden]="isReadOnly" (click)="openCreateDialog()">
      {{ 'profiles.view.add-member-activity' | translate | titlecase }}
    </a>
  </div>
</div>
<div class="activity-grid">
  <div *ngFor="let activity of pagedMemberActivities.Result; let i = index">
    <div class="activity-row mct-flex mct-row">
      <div class="activity-date mct-basis-25">{{ activity.ActivityDate | date: 'longDate' }}</div>
      <div class="activity-type mct-basis-55">{{ activity.ActivityType }}</div>
      <div class="activity-type mct-flex mct-row mct-justify-end mct-items-center mct-flex-1-1-0">
        <a class="mr-5" (click)="openEditDialog(activity)">{{
          (isReadOnly == false ? 'common.edit' : 'common.view') | translate | titlecase
          }}</a>
        <a class="delete-link" [hidden]="isReadOnly" (click)="deleteMemberActivity(activity)">{{
          'common.delete' | translate | ucfirst
          }}</a>
      </div>
    </div>
    <div *ngIf="i < memberActivity.length - 1" class="activity-divider"></div>
  </div>
  <wl-paging-controls #pagingControls [pagedResult]="pagedMemberActivities" [hidden]="!showPaging"
    (pagingEvent)="onPagingEvent($event)"></wl-paging-controls>
</div>

<p-dialog modal="true" [(visible)]="showEdit" [closable]="false" styleClass="atlas-dialog-xl" [focusOnShow]="false">
  <ng-template pTemplate="header">Member Activity</ng-template>
  <wl-profile-member-activity-editing [isReadOnly]="isReadOnly"
    [memberActivity]="editableMemberActivity"></wl-profile-member-activity-editing>
  <ng-template pTemplate="footer">
    <wl-busy *ngIf="isSaving" [show]="true"></wl-busy>
    <cancel-button [label]="'common.cancel' | translate | titlecase" [disabled]="isSaving" (onClick)="cancelEdit()">
    </cancel-button>
    <button pButton type="button" [hidden]="isReadOnly" [disabled]="isSaving" (click)="createMemberActivity()"
      class="atlas-btn atlas-btn-primary tall">
      {{ 'common.save' | translate | titlecase }}
    </button>
  </ng-template>
</p-dialog>

<p-confirmDialog #cd key="deleteMemberActivityCD"
  header="{{ 'profiles.view.member-activity.delete-header' | translate | ucfirst }}" icon="pi pi-exclamation-triangle">
  <ng-template pTemplate="footer">
    <button pButton type="button" class="atlas-btn atlas-btn-secondary tall mr-10" (click)="cd.onReject()">
      {{ 'common.cancel' | translate | uppercase }}
    </button>
    <button pButton type="button" class="atlas-btn atlas-btn-danger" (click)="cd.onAccept()">
      {{ 'common.delete' | translate | uppercase }}
    </button>
  </ng-template>
</p-confirmDialog>
